var map = {
	"./a_button.png": 5527,
	"./b_button.png": 5793,
	"./background_desert.png": 8613,
	"./background_fall.png": 1604,
	"./background_forest.png": 9337,
	"./background_grass.png": 8746,
	"./background_winter.png": 1262,
	"./crystal.png": 1829,
	"./d_pad_button.png": 1813,
	"./enemy_01.png": 4129,
	"./enemy_02.png": 2202,
	"./enemy_03.png": 925,
	"./heart_empty.png": 9568,
	"./heart_full.png": 6866,
	"./heart_half.png": 9130,
	"./key.png": 7986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 5430;
module.exports = webpackContext;